<template>
    <div class="change-password-view text-primary">
        <div>
            <v-btn variant="elevated"
                   color="primary"
                   icon="mdi-keyboard-backspace"
                   @click="goBack"
                   class="mr-1" />
        </div>

        <v-row>
            <v-spacer />
            <v-col cols="12" sm="8" md="6" lg="4">
                <div class="mt-2 mb-6 text-h4">
                    Изменение пароля
                </div>
                <div v-if="responseMessage"
                     class="mt-3 mb-5 text-success font-weight-bold">
                    <div v-text="responseMessage"></div>
                </div>

                <v-form ref="changePasswordForm"
                        @keyup.enter="changePassword"
                        @submit.prevent>
                    <div v-if="errorMessage"
                         v-text="errorMessage"
                         class="mt-3 mb-5 text-error font-weight-bold"></div>

                    <v-text-field autofocus
                                  clearable
                                  v-model="password"
                                  label="Текущий пароль"
                                  placeholder="Текущий пароль"
                                  autocomplete="off"
                                  :type="showPassword ? 'text' : 'password'"
                                  @click:prepend="showPassword = !showPassword"
                                  :prepend-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                  :rules="passwordRules" />

                    <v-text-field clearable
                                  v-model="newPassword"
                                  label="Новый пароль"
                                  placeholder="Новый пароль"
                                  autocomplete="off"
                                  :type="showNewPassword ? 'text' : 'password'"
                                  @click:prepend="showNewPassword = !showNewPassword"
                                  :prepend-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                  :rules="passwordRules" />

                    <v-text-field clearable
                                  v-model="newPasswordConfirmation"
                                  label="Подтверждение пароля"
                                  placeholder="Подтверждение пароля"
                                  autocomplete="off"
                                  :type="showNewPasswordConfirmation ? 'text' : 'password'"
                                  @click:prepend="showNewPasswordConfirmation = !showNewPasswordConfirmation"
                                  :prepend-icon="showNewPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                                  :rules="newPasswordConfirmationRules" />

                    <div class="d-flex mt-3">
                        <v-spacer />
                        <v-btn :disabled="!isValid || isDisabled"
                               @click="changePassword"
                               color="primary">
                            Изменить пароль
                        </v-btn>
                    </div>
                </v-form>
            </v-col>
            <v-spacer />
        </v-row>
    </div>
</template>

<script>
    import PagesNavigation from "@/common/pagesNavigation";
    import DataValidator from "@/common/dataValidator";

    export default {
        data() {
            return {
                password: null,
                newPassword: null,
                newPasswordConfirmation: null,

                showPassword: false,
                showNewPassword: false,
                showNewPasswordConfirmation: false,

                isDisabled: false,

                isValidForm: false,
                errorMessage: "",
                responseMessage: ""
            };
        },

        created() {
            this.$store.dispatch("loadPasswordOptions");
        },

        computed: {
            passwordRules() {
                return DataValidator.getPasswordRules(this.passwordOptions);
            },
            newPasswordConfirmationRules() {
                return DataValidator.getPasswordConfirmationRules(this.newPassword, this.passwordOptions);
            },

            passwordOptions() {
                return this.$store.state.passwordOptions;
            },

            isComplete() {
                return this.password && this.newPassword && this.newPasswordConfirmation;
            },
            isValid() {
                if (this.isComplete) {
                    this.validateForm();
                }

                return this.isComplete && this.isValidForm;
            }
        },

        methods: {
            async validateForm() {
                if (!this.$refs.changePasswordForm) {
                    return;
                }

                const { valid } = await this.$refs.changePasswordForm.validate();

                this.isValidForm = valid;
            },

            changePassword() {
                if (!this.isValid || this.isDisabled) {
                    return;
                }

                this.errorMessage = "";
                this.responseMessage = "";
                this.isDisabled = true;

                const request = {
                    currentPassword: this.password,
                    newPassword: this.newPassword
                };

                this.$store.dispatch("changePassword", request).then(response => {
                    if (!response.data.isSuccess) {
                        this.errorMessage = response.data.message;
                        this.isDisabled = false;
                        return;
                    }

                    this.responseMessage = response.data.message;
                });
            },

            goBack: PagesNavigation.goBack
        }
    };
</script>